export const componentsDefinition = `
Component Mapping:

- 'video' → playerId '3100'
- 'image' → playerId '3130' or '3140'
- 'music' → playerId '3145'
- 'extvideo' → playerId '3150'
- 'extimage' → playerId '3160'
- 'html' → playerId '3235' or '5500'
- 'richtext' → playerId '3240'
- 'label' → playerId '3241'
- 'labelqueue' → playerId '3242'
- 'message' → playerId '3245'
- 'catalogitem' → playerId '3270'
- 'catalogplayer' → playerId '3280'
- 'clock' → playerId '3320'
- 'countdown' → playerId '3322'
- 'stockitem' → playerId '3335'
- 'stockticker' → playerId '3338'
- 'podcast' → playerId '3340'
- 'rss' → playerId '3345'
- 'customrssplayer' → playerId '3346'
- 'customrssitem' → playerId '3348'
- 'camera' → playerId '3350'
- 'chart' → playerId '3400'
- 'extapp' → playerId '3410'
- 'adnet' → playerId '3420'
- 'qr' → playerId '3430'
- 'scene' → playerId '3510' or '3511'
- 'form' → playerId '3600'
- 'collection' → playerId '4100'
- 'flicking' → playerId '4101'
- 'playlist' → playerId '4102'
- 'loader' → playerId '4103'
- 'scheduler' → playerId '4104'
- 'locationbase' → playerId '4105'
- 'musiclist' → playerId '4110'
- 'hourlybalancer' → playerId '4120'
- 'xmlplayer' → playerId '4200'
- 'xmlitem' → playerId '4210'
- 'jsonlist' → playerId '4300', '4330', '4400', '4500', '6000', '6020', '6030', '6040', '6050', '6060', '6070', '6080', '6090', '6210', '6220', '6230', '6240', '6250', '6260'
- 'jsonviewer' → playerId '4305', '6010', '6022', '6500'
- 'jsonitem' → playerId '4310', '4505'
- 'youtube' → playerId '4600'
- 'serialport' → playerId '5000'
- 'knx' → playerId '5010'
- 'canva' → playerId '5600'
- 'fasterq' → playerId '6100'
- 'ayreshare' → playerId '6300', '6305', '6310', '6315', '6320', '6325', '6330', '6335', '6340', '6345', '6350'
- 'button' → playerId '7000'
- 'checkbox' → playerId '7010'
- 'numericstepper' → playerId '7020'
- 'radio' → playerId '7030'
- 'switch' → playerId '7040'
- 'textinput' → playerId '7050'
- 'slider' → playerId '7060'
- 'pttmic' → playerId '7100'
- 'pttspk' → playerId '7101'
- 'gps' → playerId '7200'
`;
